import React, { useEffect } from "react";
import { CountryCodeWithPhoneNumber } from "../../../../common/components";
import './filter-options-text.scss';

const FaxFilter: React.FC<any> = (props) => {
  const { fax, handleFaxChange, isFaxEnabled, faxError } = props;

  useEffect(() => {
    if (!isFaxEnabled) {
      handleFaxChange({ target: { value: "", name: "fax" } } as any, "fax");
    }
  }, [isFaxEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <div className="filter-options">
        <CountryCodeWithPhoneNumber
          fieldName="fax"
          placeholder="Enter Fax"
          onChange={(
            value: string,
            country: any,
            one: any,
            fullNumber: string
          ) => {
            const countryCode = country?.dialCode;

            if (!countryCode) {
              console.warn("Missing dialCode in country object");
              return;
            }
            handleFaxChange(
              { target: { value: fullNumber, name: "fax" } } as any,
              "fax"
            );
          }}
          onBlur={() => {
            props.setFieldTouched && props.setFieldTouched("fax", true);
          }}
          value={fax || "+1"}
          defaultCountry="us"
          optional={true}
          disabled={!isFaxEnabled}
        />
        {faxError && <div className="error-text">{faxError}</div>}
      </div>
    </div>
  );
};

export default FaxFilter;